(function fileDefinition() {
    'use strict';
    angular.module('Entities')
        .service('certificateService', [
            'restUrlBuilder', '$filter',
            function certificateService(restUrlBuilder, $filter) {
                var authBuilder = new restUrlBuilder('auth');

                this.downloadCertificate = function (item) {
                    var params = {
                        id: item.id,
                        UserId: item.userId,
                        OrganizationalUnitId: item.organizationalUnitId
                    };

                    return authBuilder.all('Certificate/DownloadCertificate').put(params);
                };

                this.activeCertificate = function (userId, organizationalUnitId) {
                    var params = {
                        UserId: userId,
                        OrganizationalUnitId: organizationalUnitId
                    };

                    return authBuilder.all('Certificate/ActiveCertificate').get({ params: params });
                };

                this.get = function (filters) {
                    var parameters = {
                        userId: filters.userId,
                        organizationalUnitId: filters.organizationalUnitId,
                        type: filters.certificateTypeId,
                        providerId: filters.certificateProviderId
                    };

                    return authBuilder.custom('Certificate').get({ params: parameters });
                };

                this.getAll = function (userId) {
                    return authBuilder.one('Certificate/All', userId).get();
                };

                this.getTypes = function () {
                    return authBuilder.all('Certificate/Types').get();
                };

                this.enableCertificate = function (id) {
                    return authBuilder.one('Certificate/Enable', id).put();
                };

                this.disableCertificate = function (id) {
                    return authBuilder.one('Certificate/Disable', id).put();
                };

                this.getProviders = function (type, ou) {
                    var params = {
                        typeId: type,
                        ouId: ou
                    };

                    return authBuilder.custom('Certificate/Providers').get({ params: params })
                        .then(function (res) {
                            var lakaut = $filter('filter')(res, function (item) {
                                return item.name === 'Lakaut';
                            }, true);

                            if (lakaut && lakaut.length > 0) {
                                lakaut[0].name = 'Token';
                            }
                            return res;
                        });
                };

                this.getEmployeeFileCertificates = function (filters) {
                    var cppBuilder = new restUrlBuilder('cpp');
                    return cppBuilder.custom('EmployeeFileCertificates').get({ params: filters });
                };


                this.exportToXLS = function (filters, headers, sheetName) {
                    var cppBuilder = new restUrlBuilder('cpp');
                    var params = {
                        filters: filters,
                        headers: headers,
                        sheetName: sheetName
                    };

                    return cppBuilder.custom('EmployeeFileCertificates/ExportXLS').put(params);
                };
            }
        ]);
})();